import React from "react"
import { createNativeStackNavigator } from "@react-navigation/native-stack"
import {
  ChemicalMeasurementPredictionListScreen,
  ChemicalMeasurementPredictionDetailScreen,
} from "../../screens"
import { color } from "../../theme"
import { translate } from "../../i18n"
import { CommonHeader } from "../../components"

export type MeasurementPredictionNavigatorParamList = {
  'Home.ChemicalMeasurementPrediction.List': undefined
  'Home.ChemicalMeasurementPrediction.Detail': undefined
}

const Stack = createNativeStackNavigator<MeasurementPredictionNavigatorParamList>()

export const MeasurementPredictionNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false
      }}
    >
      <Stack.Screen
        name="Home.ChemicalMeasurementPrediction.List"
        component={ChemicalMeasurementPredictionListScreen}
        options={({ navigation, route }) => ({
          title: translate('homeScreen.chemicalPredictions'),
          headerTitle: translate('homeScreen.chemicalPredictions'),
          headerShown: true,
          headerShadowVisible: false,
          headerTitleAlign: 'left',
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          header() {
            return <CommonHeader title={translate('homeScreen.chemicalPredictions')} navigation={navigation} route={route} isBeta={true} />
          },
          orientation: 'portrait'
        })}
      />
      <Stack.Screen
        name="Home.ChemicalMeasurementPrediction.Detail"
        component={ChemicalMeasurementPredictionDetailScreen}
        options={({ navigation, route }) => ({
          title: translate('common.back'),
          headerTitle: translate('common.back'),
          headerShown: true,
          headerShadowVisible: false,
          headerTitleAlign: 'left',
          headerStyle: { backgroundColor: color.primary },
          headerTintColor: color.palette.white,
          header() {
            return <CommonHeader title={translate('common.back')} navigation={navigation} route={route} />
          },
          orientation: 'landscape'
        })}
      />
    </Stack.Navigator>
  )
}
